<template>
  <div class="event-popup-footer">
    <div class="event-popup-footer__inner">
      <OCButton label="1STEPで申し込む" @click="$emit('click')" />
      <div class="event-popup-footer__next">
        <a @click.prevent="$emit('next')">次のイベントを見る</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import OCButton from '../OCButton.vue';

export default defineComponent({
  name: 'EventPopupFooter',
  components: {
    OCButton,
  },
  emits: {
    click: () => true,
    next: () => true,
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px 16px 32px;
  background-color: white;
  box-shadow: 0px 0px 6px rgba(51, 51, 51, 0.3);
}

.event-popup-footer__inner {
  width: 343px;
  margin: 0 auto;
}

.event-popup-footer__next {
  margin-top: 12px;
  text-align: center;
  a {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: $oc-gray80;
    cursor: pointer;
  }
}
</style>
